<template>
<div>
    <div class="popover-title">
        Handed to transporter
        <i class="close" @click="$emit('openClosePopup', false)" >
        <svgicon name="cancelblack-trans" width="12" height="12" />
        </i>
    </div>
    <div class="popover-body p-0">
      <Form :inline="true" class="form-default form-multi">
        <FormItem label="Truck in date">
        <DatePicker
          v-model="truckinDate"
          type="datetime"
          format="dd-MM-yyyy hh:mmA"
          placeholder="Pick a date"
          :disabled="disableEdit"
          :readonly="avoidBackDateInTruckin"
          :picker-options="truckinPickerOptions"
          size="small"
          />
        </FormItem>
        <FormItem label="Truck out date">
        <DatePicker
          v-model="truckoutDate"
          type="datetime"
          format="dd-MM-yyyy hh:mmA"
          placeholder="Pick a date"
          :readonly="avoidBackDateInTruckout"
          :picker-options="truckoutPickerOptions"
          size="small"
          />
        </FormItem>
        <FormItem label="Vehicle number" disabled>
          <Input :value="(order.vehicle && order.vehicle.number) || ''">
          </Input>
        </FormItem>
       <FormItem label="Driver mobile number" disabled>
          <Input :value="(order.driver && order.driver.mobile) || ''">
          </Input>
        </FormItem>
      </Form>
    </div>
    <div class="popover-footer pt-0 mt-15">
      <Button
        v-if="enableHandedToTransporter"
        type="primary"
        size="mini"
        @click="submit"
      >
        Submit
      </Button>
      <Tooltip
        v-else
        popper-class="max-width"
        :open-delay="200"
        effect="dark"
        placement="bottom-start"
      >
        <div slot="content">
          {{disabledReason}}
        </div>
        <span class="pointer">
          <Button
            type="primary"
            size="mini"
            :disabled="!enableHandedToTransporter">
            Submit
          </Button>
        </span>
      </Tooltip>
    </div>
</div>
</template>
<script>
import { uniqBy } from 'lodash';
export default {
  props: ['order', 'getBackDateConfig','isMasterIndentActionCompleted','lrForTruckout'],
  data() {
    return {
      truckinPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      truckinDate: new Date(),
      truckoutDate: new Date(),
      disableEdit: false,
      disabledReason: '',
    }
  },

  created() {
    this.truckinDate = this.order.sources[0].arrived_at || new Date();
    this.disableEdit = !!this.order.sources[0].arrived_at;
  },
  computed:{
    truckoutPickerOptions() {
      const truckindate = this.truckinDate;
      return {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date(truckindate).getTime() - 8.64e7
          );
        },
      };
    },
    avoidBackDateInTruckin() {
      return (this.getBackDateConfig && this.getBackDateConfig.truck_in) || false;
    },
    avoidBackDateInTruckout() {
      return (this.getBackDateConfig && this.getBackDateConfig.truck_out) || false;
    },
    enableHandedToTransporter() {
      const currentGate = this.order.sources[0]; // import indents will have only one gate
      let enableCheck = true;
      if (currentGate && this.lrForTruckout) {
        const sourceType = currentGate.gate_id ? 'source_gate_id' : 'source_location_id';
        const currentGateType = currentGate.gate_id ? 'gate_id' : 'location_id';
        const consigneeIds = this.order.destinations
          .filter(consignee => consignee[sourceType] === currentGate[currentGateType])
          .map(consignee => consignee.location_id);
        const consigneeHasLr = uniqBy(this.order.lorry_receipt, 'destination_location_id')
          .filter(val => consigneeIds.includes(val.destination_location_id));
        enableCheck = consigneeHasLr.length === [...new Set(consigneeIds)].length;
        if(!enableCheck) {
          this.disabledReason = 'LR number not available';
        }
      }
      if(!(this.order && this.order.eway_bill &&
        this.order.eway_bill.ewb_number && this.order.eway_bill.ewb_expiry_date)) {
          this.disabledReason = 'Eway bill number not available';
          enableCheck = false;
      }
      if(!this.isMasterIndentActionCompleted) {
        this.disabledReason = 'Master indent action not completed';
      }
      return (enableCheck && this.isMasterIndentActionCompleted);
    },
  },
  methods:{
    submit() {
      const payload = {
        "unique_id": this.order.sources[0].unique_id,
        "arrived_at": this.$moment(this.truckinDate),
        "dispatched_at": this.$moment(this.truckoutDate),
      };
      this.$emit('submit',payload);
    }
  },
}
</script>